<template>
  <swiper
   :options="swiperOptions"
   ref="mySwiper"
  >
    <swiper-slide v-for="(item, index) in data" :key="index">
      <div class="swiper-img-box">
        <img class="swiper-slide" :src="item.url" />
      </div>
    </swiper-slide>
    <template v-if="data.length > 3">
      <div :class="['iconfont', 'icon-jiantou', 'prev-button']" slot="button-prev"></div>
      <div :class="['iconfont','icon-jiantou', 'next-button']" slot="button-next"></div>
    </template>
    <div class="swiper-scrollbar-container" slot="scrollbar"></div>
  </swiper>
</template>
<script>
import VueTypes from 'vue-types'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'event-detail-review',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    data: VueTypes.array.def([])
  },
  data () {
    return {
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 15,
        slidesPerGroup: 1,
        loop: false,
        scrollbar: {
          el: '.swiper-scrollbar-container',
          dragClass: 'swiper-scrollbar-drag-ele'
        },
        navigation: {
          nextEl: '.next-button',
          prevEl: '.prev-button'
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~swiper/dist/css/swiper.css';

.swiper-container {
  width: 100%; height: 196px;
  position: relative;
}

.swiper-img-box {
  overflow: hidden;
  position: relative;
  width: 240px; height: 150px;
  .swiper-slide {
    position: absolute;
    display: block;
    width: 100%;
    top: 50%;
    border-radius: 4px;
    text-align: center;
    font-size: 18px;
    transform: translateY(-50%);
    transition: all .3s ease;
    &:hover {
      transform: translateY(-50%) scale(1.2);
    }
  }
}

.swiper-scrollbar-container{
  position: absolute; top: 182px;left: 50%;
  width: 180px; height: 3px;
  background: #DDD;
  border-radius: 2px;
  transform: translateX(-50%);

  ::v-deep .swiper-scrollbar-drag-ele {
    height: 3px;
    background: #D7B375;
    border-radius: 2px;
  }
}

.swiper-button-container {
  position: absolute; top: 170px; right: 0;
  display: flex;
  justify-content: space-between;
  width: 72px; height: 26px;
}

.next-button {
  position: absolute;top: 170px;right: 0;z-index: 10;
  width: 26px; height: 26px;
  border-radius: 50%;
  background: #ddd;
  text-align: center; line-height: 26px;
  font-size: 26px; color: #fff;
  cursor: pointer;

  &:hover{
    background: #D7B375;
  }
}

.prev-button {
  position: absolute;top: 170px;right: 46px;z-index: 10;
  width: 26px;  height: 26px;
  border-radius: 50%;
  background: #ddd;
  text-align: center; line-height: 26px;
  font-size: 26px; color: #fff;
  cursor: pointer;
  transform: rotate(180deg);

  &:hover{
    background: #D7B375;
  }
}

</style>
